import defaultErrorFilter from './defaultErrorFilter';

const defaultOptions = {
  filter: defaultErrorFilter,
  includeVariables: true,
  includeResponse: true,
  includeBody: true,
};

export default defaultOptions;
